// Structured discovery questionnaire mirroring the RetainProof Baseline Consultation Script.
export const CONCERN_OPTIONS = [
  "Spend rising without case growth",
  "Agency reports positive but signed matters flat",
  "Too many calls counted as leads",
  "Can't determine where retained matters originated",
  "Invoices unclear / bundled / recurring",
  "Multiple pages or listings can't be linked to results",
  "Leadership lacks confidence in current reporting",
  "Marketing director struggling to reconcile vendors",
  "Contracts approaching renewal",
  "Considering changing agencies or cutting budget",
];

export const TRIFLAG_OPTIONS = ["yes", "no", "unsure"];

export const DISCOVERY_SECTIONS = [
  {
    title: "Firm profile",
    fields: [
      { key: "practice_areas", label: "Practice areas served", type: "textarea" },
      { key: "office_locations", label: "Office locations", type: "text" },
      { key: "team_size", label: "Attorneys & intake team members", type: "text" },
      { key: "marketing_oversight", label: "Who oversees marketing performance", type: "text" },
      { key: "marketing_decision_maker", label: "Who approves marketing contracts & budgets", type: "text" },
    ],
  },
  {
    title: "Marketing investment",
    fields: [
      { key: "monthly_spend", label: "Approx. monthly marketing spend", type: "text" },
      { key: "vendor_count", label: "# of agencies / lead providers / directories paid", type: "text" },
      { key: "largest_channels", label: "Channels receiving the largest budget", type: "text" },
      { key: "bundled_or_separate", label: "Services bundled or separate", type: "select", options: ["One bundled agency", "Several providers", "Mixed"] },
      { key: "case_system", label: "Case-management / intake system", type: "text" },
      { key: "call_tracking", label: "Call-tracking provider", type: "text" },
      { key: "contract_review_frequency", label: "How often contracts & recurring charges are reviewed", type: "text" },
    ],
  },
  {
    title: "Reporting & attribution",
    fields: [
      { key: "monthly_reports", label: "Reports agencies / providers send each month", type: "textarea" },
      { key: "report_focus", label: "Reports focus on (clicks / impressions / calls / traffic / leads)", type: "text" },
      { key: "has_qualified_lead_definition", label: "Firm has an internal definition of a qualified lead", type: "triflag" },
      { key: "providers_share_definition", label: "Providers use the same definition", type: "triflag" },
      { key: "calls_classified", label: "Spam / duplicate / existing-client calls separated from qualified", type: "triflag" },
      { key: "source_identifiable", label: "Can identify which source produced each qualified conversation", type: "triflag" },
      { key: "source_traceable", label: "Source can be followed through consultation to signed matter", type: "triflag" },
      { key: "matters_in_case_system", label: "Retained matters consistently entered into case / intake system", type: "triflag" },
      { key: "calculates_cost_per_matter", label: "Firm calculates cost per retained matter", type: "triflag" },
      { key: "calculates_roi_by_vendor", label: "Firm can calculate ROI by agency / provider / channel", type: "triflag" },
      { key: "reports_match_caseload", label: "Do reported results match the firm's actual caseload & signed matters?", type: "textarea" },
    ],
  },
  {
    title: "Concerns & fit",
    fields: [
      { key: "reason_for_exploring", label: "What prompted them to explore RetainProof now", type: "textarea" },
      { key: "concerns", label: "Concerns raised", type: "multiselect", options: CONCERN_OPTIONS },
      { key: "fit_status", label: "Fit assessment", type: "select", options: ["confirmed", "unsure", "not_ready"] },
      { key: "next_step_notes", label: "Next-step notes", type: "textarea" },
    ],
  },
];
